const mechanicalColor = '#DD9E23'
const architectureColor = '#3F69FF'
const structuralColor = '#FF3B47'
const electricalColor = '#3BCBFF'
const otherColor = '#4CCC19'

export const commentsCursor =
  'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC4wMzQzIDE5LjQ3MzlDMTUuMjc2NSAxOS4zMTc5IDE5LjQ3ODMgMTUuMDE5MiAxOS40NzgzIDkuNzM5MTNDMTkuNDc4MyA0LjM2MDM2IDE1LjExNzkgMCA5LjczOTEzIDBDNC40NTk0NiAwIDAuMTYxMDI4IDQuMjAxMTYgMC4wMDQ0MjAwNSA5LjQ0Mjg3SDBWOS43MzkxM1YxOS40NzcxSDkuNTg4OTJDOS42Mzg5IDE5LjQ3NzkgOS42ODg5NyAxOS40NzgzIDkuNzM5MTMgMTkuNDc4M0M5Ljc4OTI5IDE5LjQ3ODMgOS44MzkzNiAxOS40Nzc5IDkuODg5MzQgMTkuNDc3MUgxMC4wMzQzVjE5LjQ3MzlaIiBmaWxsPSIjM0Y2OUZGIi8+Cjwvc3ZnPgo='

export enum CommentDiscipline {
  MechanicalEngineering = 'Mechanical Eng',
  Architecture = 'Architecture',
  StructuralEngineering = 'Structural Eng',
  ElectricalEngineering = 'Electrical Eng',
  Other = 'Other',
}

export const commentColorMap: { [key in CommentDiscipline]: string } = {
  [CommentDiscipline.MechanicalEngineering]: mechanicalColor,
  [CommentDiscipline.Architecture]: architectureColor,
  [CommentDiscipline.StructuralEngineering]: structuralColor,
  [CommentDiscipline.ElectricalEngineering]: electricalColor,
  [CommentDiscipline.Other]: otherColor,
}

export interface Comment {
  id?: number
  file_id?: number
  content?: string
  author_id?: number
  parent_id?: number
  resourceType?: string
  resourceId?: string
  discipline?: CommentDiscipline | null
  createdAt?: string
  updatedAt?: string
  positionX?: number
  positionY?: number
  isResolved?: boolean
}

export interface CommentWithReplies extends Comment {
  replies: Comment[]
}
